import { FaQrcode, FaTimes } from "react-icons/fa";
import { formatNumber } from "../../Hooks/FormatNumber.hook";
import { StyledQrPendingNotice } from "./style";

interface QrPendingNoticeProps {
    numbers: Array<string>;
    onOpenPanel: () => void;
    onClose: () => void;
};

// "" comes from backends that announce the QR before knowing which number will pair.
const describe = (number: string) => (number ? formatNumber(number) : "sem identificação");

export const QrPendingNotice = ({ numbers, onOpenPanel, onClose }: QrPendingNoticeProps) => {
    const message = numbers.length === 1
        ? `O número ${describe(numbers[0])} está desconectado e precisa ser pareado de novo.`
        : `${numbers.length} números estão desconectados e precisam ser pareados de novo: ${numbers.map(describe).join(", ")}.`;

    return (
        <StyledQrPendingNotice role="alert" aria-labelledby="qr-pending-notice-title">
            <FaQrcode aria-hidden />
            <div>
                <h2 id="qr-pending-notice-title">WhatsApp aguardando QR code</h2>
                <p>{message}</p>
                <button type="button" onClick={onOpenPanel}>
                    Abrir Números WhatsApp
                </button>
            </div>
            <button type="button" className="close" onClick={onClose} aria-label="Fechar aviso">
                <FaTimes aria-hidden />
            </button>
        </StyledQrPendingNotice>
    );
};
